import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import vehicleValuation from '../../../../api/bank/vehicle-valuation';
import {
  DOCUMENT_TYPES_TECH_PASSPORT,
  DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT,
  DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT,
} from '../../../../constants';
import alert from '../../../../helpers/alert';

const DocumentsForUsedCar = ({
  backHandler,
  loading,
  deal,
  chosenBankAppealId,
  chosenBankAppeal,
  setLoading,
  onSuccess,
  bankId,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();

  const onNotarialDocumentsSubmit = async (values) => {
    if (!values['techPassport']) {
      alert.error('Необходимо загрузить Технический паспорт');
      return;
    }

    if (!values['vinPhoto']) {
      alert.error('Необходимо загрузить Фото VIN-кода на панели в передней части кузова');
      return;
    }

    if (!values['odometerPhoto']) {
      alert.error('Необходимо загрузить Фото одометра, показывающего пробег');
      return;
    }

    const filesToUpload = [
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_TECH_PASSPORT,
        file: values['techPassport'],
      },
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT,
        file: values['vinPhoto'],
      },
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT,
        file: values['odometerPhoto'],
      },
    ];

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);
      if (chosenBankAppeal?.bankUniqueId) {
        try {
          await vehicleValuation(chosenBankAppeal.bankUniqueId);
          onSuccess();
        } catch (e) {
          alert.error('Ошибка при запросе оценки автомобиля от банка');
          setLoading(false);
          return;
        }
      }
    } catch (err) {
      alert.error('Ошибка загрузки документов');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'Документы'}
        hint="Документы необходимые при первичной регистрации авто"
        grid={{ display: 'grid', gap: 20 }}
        action={'Сохранить и продолжить'}
        inputs={[
          {
            text: 'Технический паспорт',
            label: 'Загрузить документ',
            name: 'techPassport',
            id: 'Технический паспорт',
            component: DocsInputNew,
          },
          {
            text: 'Фото VIN-кода на панели в передней части кузова',
            label: 'Загрузить фото',
            name: 'vinPhoto',
            id: 'Фото VIN-кода',
            component: DocsInputNew,
          },
          {
            text: 'Фото одометра, показывающего пробег',
            label: 'Загрузить фото',
            name: 'odometerPhoto',
            id: 'Фото одометра',
            component: DocsInputNew,
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default DocumentsForUsedCar;
